import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1A73E8',
        secondary: '#5f6368',
        accent: '#4285f4',
        error: '#d93025',
        success: '#1e8e3e',
        warning: '#f9ab00',
      },
    },
  },
});

